import Swiper from "swiper";
import {
    initCustomSwiper
} from "../../js/global-scripts";


var cardSlider = {
    width: Infinity,
    swiperContainer: '.projects__industry-list',
    swiperContainerWrap: '.projects__industry-list-wp',
    // swiperContainerSlide: '.projects__industry-list-wp div',
    swiperVariable: undefined,
    swiperUpdateTime: undefined,
    swiperSettings: {
        slidesPerView: 'auto',
        speed: 500,
        // watchOverflow: true,
    },
}

// Инициализация слайдера с карточками
initCustomSwiper(cardSlider);
$(window).resize(function () {
    initCustomSwiper(cardSlider);
});


// let slider = new Swiper('.projects__industry-list', {
//     slidesPerView: 'auto',
// });

$('.projects__nav-links a').on('click', function (e) {
    e.preventDefault();

    if (!$(this).hasClass('active')) {
        $('.projects__nav-links a').removeClass('active');
        $(this).addClass('active');

        $('.projects__tab').hide();
        $('.projects__tab[data-tab=' + $(this).data('tab') + ']').fadeIn();
    }

    if ($(window).width() < 768) {
        $('.projects__nav').toggleClass('projects__nav_open');
    }
});